import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import classNames from 'classnames';
import { document, window } from '../../../../helpers/BrowserHelpers';
import { EDITOR_OPEN_SLASH_COMMAND } from '../../../../types/AnalyticsTypes';
import { useFromStore } from '../../../utils/createStore';
import setToolbarPlacement from './utils/setToolbarPlacement';
import ToolbarButtons from './ToolbarButtons';
import ToolbarExpanded from './ToolbarExpanded';
var TOOLBAR_CLASS_NAME = classNames('slite-editor-toolbar', ['zindex-huge', 'margin-small', 'position-absolute', 'radius-normal']);
export default function Toolbar(_ref) {
  var editor = _ref.editor,
      store = _ref.store,
      parent = _ref.parent,
      insets = _ref.insets,
      scrollingContainer = _ref.scrollingContainer;
  var toolbar = React.useRef(null);
  var state = useFromStore(store, 'state');

  var _React$useState = React.useState({
    style: {},
    command: state.command,
    isOpen: state.isOpen,
    isExpanded: state.isExpanded
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      style = _React$useState2$.style,
      isOpen = _React$useState2$.isOpen,
      command = _React$useState2$.command,
      isExpanded = _React$useState2$.isExpanded,
      setState = _React$useState2[1];

  var isCommand = command !== null;
  var resetToolbarPlacement = React.useCallback(function () {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state;
    return setToolbarPlacement(editor, newState, parent, toolbar.current, insets, setState);
  }, [editor, state, parent, toolbar, insets, setState]);
  React.useEffect(function () {
    var recompute = function recompute() {
      return resetToolbarPlacement();
    };

    var container = scrollingContainer || document;
    container.addEventListener('scroll', recompute);
    window.addEventListener('resize', recompute);
    return function () {
      container.removeEventListener('scroll', recompute);
      window.removeEventListener('resize', recompute);
    };
  }, [scrollingContainer, resetToolbarPlacement]);
  var onMouseDown = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  var onRendered = React.useCallback(function () {
    return resetToolbarPlacement();
  }, [resetToolbarPlacement]);
  var onClosePrompt = React.useCallback(function () {
    return editor.command('closePrompt', state.prompt);
  }, [editor, state.prompt]);
  React.useEffect(function () {
    if (isOpen && isCommand) {
      editor.command('track', EDITOR_OPEN_SLASH_COMMAND);
    }
  }, [editor, isOpen, isCommand]);
  var content, dataToolbar;

  if (state.isPrompt) {
    dataToolbar = 'prompt';
    content = editor.controller.run('renderToolbarPrompt', {
      editor: editor,
      toolbarPrompt: {
        type: state.prompt
      },
      onRendered: onRendered,
      onSubmit: onClosePrompt,
      onCancel: onClosePrompt
    });
  } else if (isExpanded || isCommand) {
    dataToolbar = 'expanded';
    content = React.createElement(ToolbarExpanded, {
      editor: editor,
      command: command,
      buttons: state.buttons,
      selected: state.selected,
      hoverButton: state.hoverButton,
      onRendered: onRendered,
      isInsertion: state.isInsertion
    });
  } else {
    dataToolbar = 'buttons';
    content = React.createElement(ToolbarButtons, {
      editor: editor,
      buttons: state.buttons,
      onRendered: onRendered,
      isInsertion: state.isInsertion,
      isMinimal: state.isMinimal
    });
  }

  return React.createElement("div", {
    ref: toolbar,
    className: classNames(TOOLBAR_CLASS_NAME, state.isMinimal ? '' : 'background-white border-shade-50 with-shadow color-mode-elevated', {
      'hidden opacity-null': !isOpen || state.isDismissed
    }),
    style: style,
    onMouseDown: onMouseDown,
    "data-toolbar": dataToolbar,
    "data-toolbar-selection": state.isSelection || undefined,
    "data-toolbar-insertion": state.isInsertion || undefined,
    "data-toolbar-minimal": state.isMinimal || undefined
  }, content);
}